"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const kitchenCategories = [{
  title: "Alpine Retreats",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650028/img/alpine_mountain_expedition.png",
  link: "/DestinationsPage"
}, {
  title: "Coastal Escapes",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650028/img/coastal_mediterranean_voyage.png",
  link: "/DestinationsPage"
}, {
  title: "Desert Safaris",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650028/img/desert_dune_adventure.png",
  link: "/DestinationsPage"
}];
export default function FromOurKitchen() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="223988" id="curated-expeditions" className="bg-background text-foreground py-24 md:py-32 px-4 sm:px-6 lg:px-8 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div ref={headerRef} className={`text-center max-w-2xl mx-auto mb-16 md:mb-24 transition-all duration-1000 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-sm font-sans tracking-widest uppercase text-primary mb-4">
            The Art of Exploration
          </h2>
          <h3 className="text-4xl md:text-5xl font-default font-bold tracking-tight text-foreground">
            Curated Expeditions
          </h3>
          <p className="mt-6 text-lg text-muted-foreground font-serif italic">
            Discover a world of unparalleled beauty through our hand-selected journeys, designed for those who seek the extraordinary in every horizon.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {kitchenCategories.map((item, i) => <CategoryCard key={item.title} item={item} index={i} />)}
        </div>
      </div>
    </section>;
}
function CategoryCard({
  item,
  index
}: {
  item: {
    title: string;
    image: string;
    link: string;
  };
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <div data-index={index} ref={ref} className={`transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
    transitionDelay: `${index * 150}ms`
  }}>
      <Card className="group relative overflow-hidden border-none shadow-lg rounded-xl aspect-[3/4] bg-transparent">
        {}
        <div className="absolute inset-0 overflow-hidden">
          <img src={item.image} alt={item.title} className="w-full h-full object-cover transition-transform duration-1000 ease-out group-hover:scale-110" />
        </div>

        {}
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-60 transition-opacity duration-500 group-hover:opacity-90 backdrop-blur-[2px] group-hover:backdrop-blur-none" />

        {}
        <CardContent className="absolute inset-0 p-8 flex flex-col justify-end z-10">
          <CardTitle className="text-white text-3xl font-default font-bold tracking-wide mb-4 transform transition-transform duration-500 ease-out group-hover:-translate-y-2">
            {item.title}
          </CardTitle>
          
          <div className="overflow-hidden">
            <Button asChild variant="link" className="p-0 h-auto text-white/90 hover:text-primary text-sm font-sans tracking-widest uppercase translate-y-[120%] group-hover:translate-y-0 transition-transform duration-500 ease-out no-underline hover:no-underline">
              <Link to={item.link} className="inline-flex items-center">
                Quick View <ArrowRight className="ml-2 size-4 transition-transform duration-300 group-hover:translate-x-1" />
              </Link>
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>;
}